import React from "react";

const DeliveryEstimateIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={22} height={14}>
            <path
                fill="#1D2758"
                fillRule="nonzero"
                d="M14.43 0v2.295h2.27c1.263 0 1.767 1.263 1.956 1.722l.63 1.722.19.001c1.073 0 1.892.746 1.892 1.722V8.61H22v2.295h-2.523c0 1.262-1.136 2.295-2.523 2.295-1.388 0-2.523-1.033-2.523-2.295H8.123c0 1.262-1.136 2.295-2.523 2.295-1.388 0-2.523-1.033-2.523-2.295H.554L.55 0h13.88zm3.342 4.305c-.189-.517-.505-1.149-1.072-1.149l-2.27.001V5.74h3.848l-.506-1.435z"
            />
        </svg>
    );
};

export default DeliveryEstimateIcon;
